import React from 'react';
import { Container, Row, Col, HeaderText, TwoSlot } from 'shared-portal-component';

import AccountProfile from '@/components/organism/AccountOverview/AccountProfile/AccountProfile';
import AccountAdmins from '@/components/organism/AccountOverview/AccountAdmins/AccountAdmins';
import SubscriptionBilling from '@/components/organism/AccountOverview/SubscriptionBilling/SubscriptionBilling';
import AccountUsers from '@/components/organism/AccountOverview/AccountUsers/AccountUsers';
import '@/pages/AccountOverview/AccountOverview.scss';

import { useAccountOverview } from '@/hooks/pages/useAccountOverview';

const AccountOverview: React.FC = () => {
  const { data, busyAny } = useAccountOverview();

  return (
    <Container fluid>
      <Row spacing="md">
        <Col size={11}>
          <HeaderText
            text={`Hello ${data?.name ?? '—'}!`}
            as="h1"
            size="h1"
            className="header-text"
          />
        </Col>
      </Row>

      <Row spacing="md" className="gap-8">
        <Col size={12}>
          <TwoSlot>
            <TwoSlot.FirstSlot>
              <Col size={11} className="space-y-8">
                <AccountProfile
                  loading={busyAny}
                  name={data?.name ?? ''}
                  customerSince={data?.customerSince ?? ''}
                  phone={data?.phone ?? ''}
                  address={data?.address}
                />
                <AccountAdmins loading={busyAny} admins={data?.administrators ?? []} />
              </Col>
            </TwoSlot.FirstSlot>

            <TwoSlot.SecondSlot>
              <Col size={11} className="space-y-8">
                <SubscriptionBilling />
                <AccountUsers
                  loading={busyAny}
                  internalSeats={data?.internalSeats}
                  externalSeats={data?.externalSeats}
                />
              </Col>
            </TwoSlot.SecondSlot>
          </TwoSlot>
        </Col>
      </Row>
    </Container>
  );
};

export default AccountOverview;
